import { render, staticRenderFns } from "./App.vue?vue&type=template&id=61c8da8a&scoped=true&"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=61c8da8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c8da8a",
  null
  
)

export default component.exports